<template>
  <div class="vertical-menu">
    <div data-simplebar class="h-100">
      <div id="sidebar-menu">

        <!-- START Left Menu -->
        <ul class="metismenu list-unstyled" id="side-menu">
          <template v-for="item in menuItems">

            <li class="menu-title mt-3" v-if="item.isTitle" :key="item.id">
              {{ $t(item.label) }}
            </li>

            <li v-if="!item.isTitle && item.link !== ''" :key="item.id">
              <a v-if="hasItems(item)" href="javascript:void(0);" class="is-parent"
                 :class="{ 'has-arrow': !item.badge, 'has-dropdown': item.badge }">
                <i :class="`bx ${item.icon}`" v-if="item.icon" />
                <span>{{ $t(item.label) }}</span>
                <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">
                  {{ item.badge.text }}
                </span>
              </a>

              <router-link :to="item.link" v-if="!hasItems(item)" class="side-nav-link-ref">
                <i :class="`bx ${item.icon}`" v-if="item.icon" />
                <span>{{ $t(item.label) }}</span>
                <span :class="`badge rounded-pill bg-${item.badge.variant} float-end`" v-if="item.badge">
                  {{ item.badge.text }}
                </span>
              </router-link>

              <ul v-if="hasItems(item)" class="sub-menu" aria-expanded="false">
                <li v-for="(subitem, index) of item.subItems" :key="index">
                  <router-link :to="subitem.link" v-if="!hasItems(subitem)" class="side-nav-link-ref">
                    {{ $t(subitem.label) }}
                  </router-link>
                  <a v-if="hasItems(subitem)" class="side-nav-link-a-ref has-arrow" href="javascript:void(0);">
                    {{ $t(subitem.label) }}
                  </a>
                  <ul v-if="hasItems(subitem)" class="sub-menu mm-collapse" aria-expanded="false">
                    <li v-for="(subSubitem, index) of subitem.subItems" :key="index">
                      <router-link :to="subSubitem.link" class="side-nav-link-ref">
                        {{ $t(subSubitem.label) }}
                      </router-link>
                    </li>
                  </ul>
                </li>
              </ul>
            </li>

            <li v-if="!item.isTitle && item.link === ''" :key="item.id" >
              <router-link :to="item.link" class="side-nav-link-ref disable-link-menu"
                           style="color: #b4b3b3" :style="{pointerEvents: 'none'}">
                <i :class="`bx ${item.icon}`" v-if="item.icon" style="color: #b4b3b3" />
                <span>{{ $t(item.label) }}</span>
              </router-link>
            </li>

          </template>
        </ul>
        <!-- END Left Menu -->

        <!-- START Copyright -->
        <div style="position: fixed; bottom: 0">
          <div class="font-size-12 text-muted p-3">© 2022. I-ON Communications,<br/>All rights reserved.</div>
        </div>
        <!-- END Copyright -->

      </div>
    </div>
  </div>
</template>

<script>
import MetisMenu from 'metismenujs/dist/metismenujs';
import simplebar from 'simplebar-vue';

import { layoutComputed } from '@/state/helpers';
import { menuItems } from './menu';

export default {
  components: { simplebar },
  computed: { ...layoutComputed },
  data() {
    return {
      menuItems: menuItems,
      logoutMenuItems: [
        { name: 'Dashboard', icon: 'bxs-dashboard' },
        { name: '충전소 이용 현황', icon: 'bx-spreadsheet' },
        { name: '통계 리포트', icon: 'bx-line-chart' },
        { name: '매출 현황', icon: 'bx-money' },
        { name: '이용자 분석 서비스', icon: 'bx-analyse' },
        { name: '수요 관리 서비스', icon: 'bx-building-house' },
        { name: '운영 관리', icon: 'bx-cog' }
      ]
    };
  },
  mounted() {
    // eslint-disable-next-line no-unused-vars
    let menuRef = new MetisMenu('#side-menu');
    let links = document.getElementsByClassName('side-nav-link-ref');
    let matchingMenuItem = null;
    const paths = [];

    // Check User Permission (Menu)
    if (this.$_utils.isEmpty(this.$_app.user.roles)) {
      this.menuItems = this.menuItems.filter(item => !item.authRequired);

      this.logoutMenuItems.forEach((item, i) => {
        this.menuItems.push({
          authRequired: false,
          icon: item.icon,
          id: 11+i,
          label: item.name,
          link: '',
          roles: []
        })
      });
    }
    else {
      this.menuItems = this.menuItems.filter(item => {

        for (const role of item.roles) {
          if (!this.$_app.user.roles.includes(role)) {
            return false;
          }
        }
        return true;
      });
    }

    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }

    let itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      matchingMenuItem = links[paths.indexOf(item)];
    } else {
      matchingMenuItem = links[itemIndex];
    }

    if (matchingMenuItem) {
      matchingMenuItem.classList.add('active');
      let parent = matchingMenuItem.parentElement;

      if (parent) {
        parent.classList.add('mm-active');
        const parent2 = parent.parentElement.closest('ul');

        if (parent2 && parent2.id !== 'side-menu') {
          parent2.classList.add('mm-show');
          const parent3 = parent2.parentElement;

          if (parent3) {
            parent3.classList.add('mm-active');
            let childAnchor = parent3.querySelector('.has-arrow');
            let childDropdown = parent3.querySelector('.has-dropdown');

            if (childAnchor) childAnchor.classList.add('mm-active');
            if (childDropdown) childDropdown.classList.add('mm-active');

            const parent4 = parent3.parentElement;

            if (parent4 && parent4.id !== 'side-menu') {
              parent4.classList.add('mm-show');
              const parent5 = parent4.parentElement;

              if (parent5 && parent5.id !== 'side-menu') {
                parent5.classList.add('mm-active');
                const childanchor = parent5.querySelector('.is-parent');

                if (childanchor && parent5.id !== 'side-menu') {
                  childanchor.classList.add('mm-active');
                }
              }
            }
          }
        }
      }
    }
  },
  watch: {
    type: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'default':
              document.body.setAttribute('data-sidebar-size', 'lg');
              break;
            case 'compact':
              document.body.setAttribute('data-sidebar-size', 'md');
              document.body.classList.remove('vertical-collpsed');
              break;
            case 'icon':
              document.body.setAttribute('data-sidebar-size', 'sm');
              break;
            default:
              document.body.setAttribute('data-sidebar-size', 'lg');
              break;
          }
        }
      }
    },
    width: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'boxed':
              document.body.setAttribute('data-layout-size', 'boxed');
              break;
            case 'fluid':
              document.body.setAttribute('data-layout-size', 'fluid');
              break;
            default:
              document.body.setAttribute('data-layout-size', 'fluid');
              break;
          }
        }
      }
    },
    color: {
      immediate: true,
      handler(newVal, oldVal) {
        if (newVal !== oldVal) {
          switch (newVal) {
            case 'light':
              document.body.setAttribute('data-sidebar', 'light');
              break;
            case 'dark':
              document.body.setAttribute('data-sidebar', 'dark');
              break;
            case 'brand':
              document.body.setAttribute('data-sidebar', 'brand');
              break;
            default:
              document.body.setAttribute('data-sidebar', 'dark');
              break;
          }
        }
      }
    }
  },
  methods: {
    hasItems(item) {
      return item.subItems !== undefined ? item.subItems.length > 0 : false;
    },
    toggleMenu(event) {
      event.currentTarget.nextElementSibling.classList.toggle('mm-show');
    }
  }
};
</script>
